export const STATIC = 'STATIC_DATE';
export const RECURRING = 'RECURRING_DATE';